"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _Item = _interopRequireDefault(require("../List/Item"));
var _Button = _interopRequireDefault(require("../Button"));
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** @jsxImportSource @emotion/react */

const Option = ({
  trackingEvent,
  trackingName,
  ...props
}) => {
  const onChange = () => {
    if (props.onChange && !props.disabled) {
      props.onChange({
        value: props.value
      });
    }
  };
  return (0, _jsxRuntime.jsx)(_Item.default, {
    children: (0, _jsxRuntime.jsx)(_Button.default, {
      nostyle: true,
      css: (0, _styles.optionButton)(props.indent),
      onClick: onChange,
      trackingEvent: trackingEvent,
      trackingName: trackingName,
      disabled: props.disabled,
      children: _react.default.Children.map(props.children, child => {
        return child;
      })
    }, props.key)
  });
};
var _default = exports.default = Option;